<template>
    <div class="main-allocation">
      <main>
        <!-- 表格搜索栏 -->
        <div class="toolbar">
          <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
            <a-form-model-item prop="searchText">
              <a-input-search v-model.trim="pagination.searchText" placeholder="部门"
                              style="width: 200px; " allow-clear :loading="btnLoad" @input="searchTextChange" />
            </a-form-model-item>
            <a-form-model-item >
              <a-button  @click="resetSearch">重 置</a-button>
            </a-form-model-item>
            <!-- <a-form-model-item prop="orgId">
            <a-tree-select allowClear v-model='pagination.orgId'
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="treeData" placeholder="选择部门"
              style="width: 200px;" @change="searchChange" tree-default-expand-all
              :replaceFields="{ title: 'name', key: 'id', value: 'id' }">
            </a-tree-select>
          </a-form-model-item> -->
          </a-form-model>
            <!-- <a-button v-if="$IA('system:robot:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加</a-button> -->
        </div>
        <!-- 数据表格 -->
        <a-table :columns="tableColumns" bordered :data-source="tableData" :pagination="queryCondition" :loading="tableLoad"
          @change="handleTableChange" :scroll="{ y: 560 }">
          <span slot="action" slot-scope="record">
           <a-tooltip  content="" v-if="$IA('system:robot:update')" title="分配许可证" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('分配许可证', record)" ></i>
            </a-tooltip>
<!--            <a-dropdown placement="bottomRight" :trigger="['click']">-->
<!--              <i class="ant-dropdown-link table-action" />-->
<!--              <a-menu slot="overlay">-->
<!--                <a-menu-item v-if="$IA('system:robot:update')" @click="handleOpen('分配许可证', record)">-->
<!--                  <a-icon type="edit" /><span>分配许可证</span>-->
<!--                </a-menu-item>-->
<!--              -->
<!--              </a-menu>-->
<!--            </a-dropdown>-->
          </span>
        </a-table>
      </main>
  
      <!-- 操作模态框 -->
      <a-modal centered :title="modalTitle + ': '+ '机器人'" :visible="modalVisible" :confirm-loading="btnLoad"
        @ok="handleOk('addForm')" @cancel="resetForm" width="580px" :confirmLoading="submitLoad" :maskClosable="false">
        <a-form-model layout="vertical" ref="addForm"    :model="addForm"
          >
              <a-form-model-item prop="id" v-show="false">
                <a-input v-model="addForm.id" placeholder="请输入" />
              </a-form-model-item>
              <a-form-model-item prop="orgName" label="部门">
                <a-input v-model="addForm.orgName" placeholder="请输入" disabled />
              </a-form-model-item>                     
              <a-form-model-item prop="attendedNum" label="有人值守" 
              :rules="[
                { required: true, message: '有人值守不能为空' },
                { pattern:  /^([0-9]|[1-9]\d|100)$/,message:'无法分配超过'+ this.assembleSomeoneValue + '个,且不能为空'}
                ]"
              >
                <a-input ref="userNameInput" @input="attendChange()" v-model="addForm.attendedNum" type="number"  placeholder="请输入" style="position:relative;">
                  <a-statistic  slot="suffix" :value="someoneValue" class="demo-class">
                      <template #suffix>
                        <span> / {{ assembleSomeoneValue }}</span>
                      </template>
                    </a-statistic>
                </a-input>
                <div class="pslaceholder"></div> 
              </a-form-model-item>
              <a-form-model-item prop="unAttendedNum" label="无人值守"
              :rules="[
                { required: true, message: '无人值守不能为空' },
                { pattern:  /^([0-9]|[1-9]\d|100)$/,message:'无法分配超过'+ this.assembleSomeoneValue + '个,且不能为空'}
                ]">
                <a-input ref="userNameInput" @change="attendChange()" v-model="addForm.unAttendedNum"  type="number" placeholder="请输入"  style="position:relative;">
                  <a-statistic  slot="suffix" :value="unmannedValue" class="demo-class">
                      <template #suffix>
                        <span> / {{assembleUnmannedValue}}</span>
                      </template>
                    </a-statistic>
                </a-input>
                <div class="pslaceholder"></div> 
              </a-form-model-item>
              <a-form-model-item prop="studioNum" label="设计器"
              :rules="[
                { required: true, message: '设计器不能为空' },
                { pattern:  /^([0-9]|[1-9]\d|100)$/,message:'无法分配超过'+ this.assembleSomeoneValue + '个,且不能为空'}
                ]"
              >
                <a-input ref="userNameInput" @change="attendChange()" v-model="addForm.studioNum"  type="number" placeholder="请输入" style="position:relative;">
                  <a-statistic  slot="suffix" :value="studioValue" class="demo-class">
<!--                      <template #suffix>-->
<!--                        <span> / {{assembleStudioValue}}</span>-->
<!--                      </template>-->
                    </a-statistic>
                </a-input>
                <div class="pslaceholder"></div> 
              </a-form-model-item>


        </a-form-model>
        <a-alert v-if="modalTitle == '删除'" message="确定继续吗？" description="* 此操作将删除该机器人." type="warning" show-icon />
      </a-modal>
    </div>
  </template>
  
  <script>

  import {notification} from "ant-design-vue";

  export default {
    data() {
      return {
        btnLoad: false,
        tableLoad: false,
        pagination: {
          searchText: '',
          pageSize: 10,
          current: 1,
          total: 0,
          orgId:undefined,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
        },
        tableColumns: [
          {
            title: "序号",
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 65,
            customRender: (text, record, index) => `${index + 1}`,
          },
          {
            title: '部门',
            dataIndex: 'orgName',
            key: 'orgName',
            ellipsis: true,
          },
          {
            title: '无人值守',
            dataIndex: 'unAttendedNum',
            key: 'unAttendedNum',
            ellipsis: true,
            
          },
          {
            title: '有人值守',
            key: 'attendedNum',
            dataIndex: 'attendedNum',
            ellipsis: true,
  
          },
          {
            title: '设计器数量',
            key: 'studioNum',
            dataIndex: 'studioNum',
            ellipsis: true, 
          },
          {
            title: '更新时间',
            key: 'updateTime',
            dataIndex: 'updateTime',
            ellipsis: true,
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: "action" },
            align: 'center',
            width: 100,
          },
        ],
        formLayout: "inline",
        queryCondition: {},
        // 部门列表
        tableData: [],
        // 模态框显隐
        modalVisible: false,
        // 模态框标题
        modalTitle: '',
        // 单行数据
        singleDta: "",
        // 是否按钮loading
        submitLoad: false,
        saveApi: "", // 添加/修改保存API
        // 添加表单
        addForm: {
          id: "",
          orgId: "",
          orgName:'',
          attendedNum:0,
          unAttendedNum:0,
          studioNum:0
        },
        // 机器人下拉数据
        robotList: {},
        // 分页参数
        pagCurrent:{},
        // 部门列表
        treeData: [],

        // 分配剩余
        someoneValue:0,
        unmannedValue:0,
        studioValue:0,

        // 分配总数
        assembleSomeoneValue:0,
        assembleUnmannedValue:0,
        assembleStudioValue:0,

        // 分配剩余克隆字段
        attendedValue:0,
        unAttendedValue:0,
        studioNumValue:0
      }
    },
    methods: {
      // 重置表单通用方法
      resetForm() {
        this.$refs.addForm.resetFields()
        this.modalVisible = false
      },
      // 重置搜索
      resetSearch() {
        this.$refs.searchBar.resetFields()
        this.searchChange()
      },
      
      // 判断设备数量
      attendChange(){
  
        // 无人值守
        if (this.addForm.attendedNum) {
          this.addForm.attendedNum = parseInt(this.addForm.attendedNum)
          if (this.addForm.attendedNum < this.assembleSomeoneValue) {
            this.someoneValue = this.assembleSomeoneValue - this.addForm.attendedNum - this.attendedValue 
          }else{
            this.someoneValue = 0
          }
        }else{
          this.someoneValue = this.assembleSomeoneValue - this.attendedValue 
        
        }
        
       
        // 有人值守
        if (this.addForm.unAttendedNum) {
          this.addForm.unAttendedNum = parseInt(this.addForm.unAttendedNum)
          if (this.addForm.unAttendedNum < this.assembleUnmannedValue) {
            this.unmannedValue = this.assembleUnmannedValue - this.addForm.unAttendedNum - this.unAttendedValue 
          }else{
            this.unmannedValue = 0
          }
        }else{
          this.unmannedValue = this.assembleUnmannedValue - this.unAttendedValue 
        }

      // 设计器
      this.addForm.studioNum = parseInt(this.addForm.studioNum)
        if ( this.addForm.studioNum) {

          if (this.addForm.studioNum < this.assembleStudioValue) {
            this.studioValue = this.assembleStudioValue - this.addForm.studioNum - this.studioNumValue 
          }else{
            this.studioValue = 0
          }

        }else{
          this.studioValue = this.assembleStudioValue - this.studioNumValue 
        }

      },
      // 打开模态框
      handleOpen(title, data) {
        this.modalTitle = title
        this.modalVisible = true
        this.$nextTick(() => {
          this.singleDta = data
          switch (title) {
            case '分配许可证':
              this.saveApi = '/licenseOrg/update'
              this.addForm = this.$lodash.pick(
                this.singleDta,
                this.$lodash.keys(this.addForm)
              );
              this.axios
                .post("/licenseOrg/findNumById",{orgId:data.orgId})
                .then((res) => {
                  console.log(res.data);
                  if (res.code === 200) {
                    this.someoneValue =  res.data.useAttendedNum
                    this.unmannedValue =  res.data.useUnAttendedNum
                    this.studioValue =  res.data.useStudioNum

                    this.assembleSomeoneValue = res.data.allAttendedNum
                    this.assembleUnmannedValue = res.data.allUnAttendedNum
                    this.assembleStudioValue = res.data.allStudioNum

                    this.attendedValue =  this.$lodash.cloneDeep(res.data.useAttendedNum);
                    this.unAttendedValue =  this.$lodash.cloneDeep(res.data.useUnAttendedNum);
                    this.studioNumValue =  this.$lodash.cloneDeep(res.data.useStudioNum);

                    this.someoneValue = this.assembleSomeoneValue -  res.data.useAttendedNum - this.addForm.attendedNum
                    this.unmannedValue = this.assembleUnmannedValue -  res.data.useUnAttendedNum - this.addForm.unAttendedNum 
                    this.studioValue = this.assembleStudioValue -  res.data.useStudioNum - this.addForm.studioNum  
                  }   
                })
                .catch((err) => {
                  console.log(err);
                });
               
              break;
          }
        })
      },
      // 确认模态框
      handleOk(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
              this.submitLoad = true;
              let saveData = this.$lodash.cloneDeep(this.addForm);
              this.axios
                .post(this.saveApi, saveData)
                .then((res) => {
                  this.submitLoad = false;
                  if (res.code === 200) {
                    this.handleTableChange(this.pagCurrent);
                    this.modalVisible = false;
                    notification.success({
                      message: res.message,
                      duration: 3,
                      customClass: "batch-import",
                    })
                    this.$refs.addForm.resetFields()
                  }
                }) 
                .catch((err) => {
                  this.submitLoad = false;
                  console.log(err);
                });
            } else {
              console.log("error submit!!");
              return false;
            }
          });
      },
      // 机器人下拉框
      allRobotList(id) {
        this.axios
          .post("/machine/findMachines", 'orgId=' + (id ? id : ''))
          .then((res) => {
            // console.log(res.data);
            if (res.code === 200) {
              this.robotList = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      // // 部门下拉框
      // allorgList() {
      //   this.axios
      //     .post("org/findPage", '')
      //     .then((res) => {
      //       if (res.code === 200) {
      //         this.treeData = res.data;
      //       }
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // },
      // 监听搜索输入框输入
      searchTextChange(val) {
        if (window.searchTimer) {
          clearTimeout(searchTimer);
        }
        window.searchTimer = setTimeout(() => {
          this.searchChange(val)
        }, 1200);
      },
      // 搜索
      searchChange(v) {
        this.queryCondition = this.$lodash.cloneDeep(this.pagination)
        this.tableAjax()
      },
      // 监听翻页
      handleTableChange(pagination, filters, sorter) {
        this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
        this.queryCondition.current =  pagination.current ? pagination.current : 1
        this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
        this.pagCurrent = pagination ? pagination:this.pagination
        this.tableAjax()
      },
      // 翻页请求
      tableAjax() {
        this.tableLoad = true
        this.axios.post('/licenseOrg/findPage', this.$qs.stringify(this.queryCondition)).then((res) => {
          this.tableLoad = false
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        }).catch((err) => {
          console.log(err);
          this.tableLoad = false
        })
      },
    },
    beforeMount() {
      this.searchChange()
      // this.allorgList()
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .main-allocation {

  
    main {
      margin: 16px 0 0px 0;
      background-color: #fff;
      border-radius: 2px;
      header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid #f0f0f0;

        h3 {
          margin-bottom: 0;
          height: 18px;
          line-height:17px;
          padding-left: 12px;
          border-left: 4px solid #3373F2;
          font-size: 16px;
          font-weight: bold;
          color: #3d4966;
        }

        span {
          line-height: 16px;
          margin-left: 10px;
          color: #808080;
        }
      }
      .toolbar {
        display: flex;
        justify-content: space-between;
        padding: 16px;

        .search-bar {
          flex: 1;
        }
        .ant-form{
          .ant-form-item{
            margin-right: 16px;
          }
          .ant-form-item:last-child{
            .ant-btn{
              width: 74px;
              position: absolute;

            }
          }
        }
      }
      .ant-table-wrapper{
        padding: 0 16px 16px;
      }
    }

  }

   ::v-deep .ant-statistic-content{
        margin-bottom: 8px;
      .ant-statistic-content-value{
        color: #3471fa;
        font-weight: 600;
        font-size: 16px;
      }
      .ant-statistic-content-suffix{
        font-weight: 600;
      }
     }
     .pslaceholder{
      position: absolute;
      display: inline-block;
      background-color: #ffffff;
      right: 30px;
      bottom: 1px;
      width: 20px;
      height: 20px;
     }
  </style>